import React, { useEffect, useRef } from 'react';
import { Grid, GridProps } from '../grid/grid';
import { Calendar, CalendarProps } from '../calendar/calendar';
import { TaskGanttContent, TaskGanttContentProps } from './task-gantt-content';
import styles from './gantt.module.css';
import { ChartType } from '../../types/public-types';

export type TaskGanttProps = {
  gridProps: GridProps;
  calendarProps: CalendarProps;
  barProps: TaskGanttContentProps;
  ganttHeight: number;
  scrollY: number;
  scrollX: number;
  chartType: ChartType;
  viewMode: string;
};
export const TaskGantt: React.FC<TaskGanttProps> = ({
                                                      gridProps,
                                                      calendarProps,
                                                      barProps,
                                                      ganttHeight,
                                                      scrollY,
                                                      scrollX,
                                                      chartType,
                                                      viewMode,
                                                    }) => {
  const ganttSVGRef = useRef<SVGSVGElement>(null);
  const horizontalContainerRef = useRef<HTMLDivElement>(null);
  const verticalGanttContainerRef = useRef<HTMLDivElement>(null);
  const newBarProps = { ...barProps, chartType, svg: ganttSVGRef };

  useEffect(() => {
    if (horizontalContainerRef.current) {
      horizontalContainerRef.current.scrollTop = scrollY;
    }
  }, [scrollY]);

  useEffect(() => {
    if (verticalGanttContainerRef.current) {
      verticalGanttContainerRef.current.scrollLeft = scrollX;
    }
  }, [scrollX]);

  return (
    <div
      className={ styles.ganttVerticalContainer}
      ref={verticalGanttContainerRef}
      dir="ltr"
      style={{width: '100%', overflowX:'scroll'}}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={gridProps.svgWidth}
        height={calendarProps.headerHeight}
        fontFamily={barProps.fontFamily}
        style={{overflow: 'scroll !important'}}
      >
        <Calendar {...calendarProps} />
      </svg>
      <div
        ref={horizontalContainerRef}
        //className={styles.horizontalContainer}
        className={ "gantt4k" }
        style={
          ganttHeight
            ? { height: ganttHeight, width: gridProps.svgWidth }
            : { width: gridProps.svgWidth }
        }
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={gridProps.svgWidth}
          height={(barProps.rowHeight * barProps.tasks.length)}
          fontFamily={barProps.fontFamily}
          ref={ganttSVGRef}
        >
          <Grid {...gridProps} />
          <TaskGanttContent {...newBarProps} />
        </svg>
      </div>
    </div>
  );
};
